import * as z from "zod";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { mutator } from "./mutator";
import { branchSchema, insertUserAction } from "./utils";

export const updateStepTimeout = mutator({
  schema: z
    .object({
      stepDir: z.string(),
      timeout: z.number().int().min(1).max(300).optional(),
    })
    .merge(branchSchema),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      timeout,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    const { commitId } = await ensureWritable(
      tx,
      ctx.userId,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );
    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, { timeout });
    await insertUserAction(
      tx,
      commitId,
      ctx.userId,
      ctx.tenantId,
      "updateStepTimeout",
      {
        stepDir,
        timeout: timeout ?? null,
      }
    );
  },
});
